import { uuidv4 } from "@firebase/util";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

// custom components
import Comments from "../../components/customs/Comments";
import { SuggestedUsers } from "../../components/customs/SuggestedUsers";

// Wrappers
import { useDispatch, useSelector } from "react-redux";
import {
  MainWithSide as Main,
  MainWithSideWrapper,
  Side
} from "../../components/containers/Wrappers";

// loader and error
import { useRef } from "react";
import PostItem from "../../components/customs/PostItem";
import { addCommentMiddleware, getCommentsMiddleware, getPostByIdMiddleware } from "../../redux/middlewares/PostMiddleware";
import { addCommentSuccess, getPostError, getPostSuccess, resetActionType } from "../../redux/slices/PostSlice";
import ErrorPage from "./ErrorPage";
import LoadingPage from "./LoadingPage";
import { toast } from "react-toastify";

export default function PostDetails({ }) {
  //redux
  const authenticateState = useSelector((state) => state.authenticate);
  const postState = useSelector((state) => state.post);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const commentInputRef = useRef();

  React.useEffect(() => {

    dispatch(getPostByIdMiddleware(id));
  }, [id]);

  React.useEffect(() => {
    if (postState.ACTION_TYPE === getPostError.toString()) {
      dispatch(resetActionType());
    }else if (postState.ACTION_TYPE === getPostSuccess.toString()) {
      dispatch( getCommentsMiddleware(id));
      dispatch(resetActionType());
    }
    else if (postState.ACTION_TYPE === addCommentSuccess.toString()) {

      toast.success("Comment added successfully");

      dispatch( getCommentsMiddleware(id));
      dispatch(resetActionType());
    }
  }, [postState.ACTION_TYPE]);

  if (postState.isGetPostLoading) {
    return <LoadingPage />;
  }

  if (postState.ACTION_TYPE === getPostError.toString()) {
    return <ErrorPage />;
  }

  return (
    <MainWithSideWrapper>
      {/* Main Page Items */}
      {/* ---------------------------------------------------------------- */}
      <Main className="pt-3">
        <div className="flex flex-column gap-5 mt-4 pb-8">
          {!postState.isGetPostLoading &&
            <>
              <PostItem
                item={postState.post}
                currentUserId={authenticateState.user_id}
                onEditPost={() => alert("edit post")}
                onDeletePost={() => alert("delete post")}
                onLikeClick={() => alert("i liked a post")}
                onCommentClick={() => commentInputRef.current.focus()}
                shareData={{
                  text: "I saw this awesome post on justis social.",
                  url: window.location.href,
                  title: "Justis Social",
                }}
                onAvatarClick={() => navigate(`/profile/${postState.post?.userId}`)}
                likeCount={10}
                commentCount={10}
                liked={true}
              />

              <Comments 
                inputRef ={commentInputRef}
                isAddCommentLoading ={postState.isAddCommentLoading}
                isGetCommentsLoading ={postState.isGetCommentsLoading}
                onAddComment = { (comment) =>{

                  const id = Date.now();

                  const commentObject ={
                    id:id.toString(),
                    createdBy:authenticateState.user,
                    comment: comment,
                    createdAt: id,
                  }

                  dispatch( addCommentMiddleware(postState.post.id, id.toString(), commentObject))
                  
                }}
                comments={postState?.comments ?? []} />
            </>
          }
        </div>
      </Main>
      {/* ---------------------------------------------------------------- */}

      {/* Suggested Users Component */}
      {/* ---------------------------------------------------------------- */}
      <Side>
        <SuggestedUsers
        // data
        />
      </Side>
      {/* ---------------------------------------------------------------- */}
    </MainWithSideWrapper>
  );
}
